const auxillary = (props) => props.children;

export default auxillary;


// WEBPACK FOOTER //
// ./src/hoc/Auxillay.js